// Cart lines keep the price from when they were added (localStorage), so a
// price change in the POS would otherwise leave old prices in the cart and the
// checkout summary while the server charges the new ones. This re-prices lines
// from the current public product list. Products missing from the list (no
// longer sold online) are left as they are; checkout rejects them with a message.
const samePrice = (a, b) => (a == null && b == null) || (a != null && b != null && Number(a) === Number(b));

export const repriceLines = (lines, products) => {
  const byId = new Map((products || []).map((product) => [Number(product.id), product]));
  let changed = false;
  const next = lines.map((line) => {
    const product = byId.get(Number(line.productId));
    if (!product) return line;
    const price = product.price;
    const discountedPrice = product.discounted_price ?? null;
    const name = product.name || line.name;
    const image = product.signed_url || line.image || null;
    if (samePrice(line.price, price)
      && samePrice(line.discountedPrice, discountedPrice)
      && line.name === name
      && line.image === image) {
      return line;
    }
    changed = true;
    return { ...line, price, discountedPrice, name, image };
  });
  return changed ? next : lines;
};
